<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <StatusForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import StatusForm from '@/components/settings/stock-registers/status/StatusForm'

export default {
  name: 'StatusAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    StatusForm
  }
}
</script>
